module.exports = __webpack_public_path__ + "static/image-1-0529271eecb41cdaea2832b1fa61b4e4.png";